import React from "react";

import { graphql } from "gatsby";

import Button from "cms/components/Button";
import OptimizedImage from "cms/components/OptimizedImage";
import Text from "cms/components/Text";
import { getImage } from "helpers/getImage";

import {
  Container,
  Content,
  Description,
  HeaderContainer,
  IllustrationContainer,
  Link,
  Template,
  TemplateContainer,
  TemplateLink,
} from "./TemplateCategoryBlock.styles";

export interface TemplateCategoryBlockProps
  extends Queries.SanityTemplateCategoryBlock {
  pageContext?: {
    imageCache: Record<string, any>;
  };
}

const TemplateCategoryBlock: React.FC<TemplateCategoryBlockProps> = ({
  headline,
  description,
  category,
  templates,
  pageContext,
}) => (
  <Container>
    <Content>
      <HeaderContainer>
        <Text variant="H3" as="h2">
          {headline}
        </Text>
        <Link href={`${category?.slug}`}>
          <Button label="Show all" variant="secondary" />
        </Link>
      </HeaderContainer>

      <Description>{description}</Description>
      <TemplateContainer>
        {templates
          ?.filter(
            (template): template is Queries.SanityTemplatePage => !!template,
          )
          .map((template) => (
            <TemplateLink href={`${template.slug}`} key={template.slug}>
              {template.coverImage &&
                template.displayedNameInOverview &&
                pageContext && (
                  <Template>
                    <IllustrationContainer>
                      <OptimizedImage
                        image={getImage(
                          template.coverImage,
                          pageContext?.imageCache,
                        )}
                        alt={template.coverImageAlt}
                      />
                    </IllustrationContainer>
                    <Text
                      variant="B2"
                      as="p"
                      marginTop="0.5rem"
                      weight="medium"
                    >
                      {template.displayedNameInOverview}
                    </Text>
                  </Template>
                )}
            </TemplateLink>
          ))}
      </TemplateContainer>
    </Content>
  </Container>
);

export const query = graphql`
  fragment TemplateCategoryBlock on SanityTemplateCategoryBlock {
    _key
    _type
    headline
    description
    category {
      _id
      name
      slug
    }
    templates {
      _id
      name
      displayedNameInOverview
      slug
      coverImage {
        ...OptimizedImage
      }
    }
  }
`;

export default TemplateCategoryBlock;
